import { render, staticRenderFns } from "./DriverActivityChart.vue?vue&type=template&id=64d0f16c"
import script from "./DriverActivityChart.vue?vue&type=script&lang=js"
export * from "./DriverActivityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports